// extracted by mini-css-extract-plugin
export default {"InstallExtensionInstructions":"install-extension-instructions__InstallExtensionInstructions__zk9bk"};